// src/components/GoogleLogin.js
import React from 'react';
import { GoogleOAuthProvider, GoogleLogin } from '@react-oauth/google';
import { GoogleLoginApi } from '../../../api/request/auth';
import { setloggedIn, setUserDetails } from '../../../store/Slices/userSlice';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import toast from 'react-hot-toast';
import { setCookies } from '../../../services/Cookies';
import { Cookies } from 'react-cookie';
import siteConfig from '../../../config';

const GoogleLoginComponent = () => {
    const cookies = new Cookies();
    const { token, loginToken, passwordToken } = cookies.getAll();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const handleSuccess = async (response) => {
        try {
            let params = { google_token: response.credential };
            let header = {
                Accept: "application/json",
                "Content-Type": "application/json",
                Authorization: `Bearer ${loginToken}`
            }
            const { data } = await GoogleLoginApi(params, header);
            if (data?.status) {
                dispatch(setloggedIn(true));
                dispatch(setUserDetails(data?.data));
                setCookies('token', data?.token);
                toast.success(data?.message);
                navigate('/dashboard');
            }
        } catch (error) {
            if (error?.response?.data?.message) {
                toast.error(error?.response?.data?.message);
            }
        }

    };

    const handleFailure = (error) => {
        console.error('Login Failed:', error);
    };

    return (
        <GoogleOAuthProvider clientId="718192575358-jsv38hvaetf2363u7q78ddh4um2s0r6q.apps.googleusercontent.com" >
            <div className='me-4'>
                <GoogleLogin
                    allowed_parent_origin=""
                    onSuccess={handleSuccess}
                    onError={handleFailure}
                    theme='outline'
                    useOneTap
                    redirectUri={`https://client.${siteConfig.name.toLowerCase()}.ca`}
                    cookiePolicy={'single_host_origin'}
                >
                </GoogleLogin>
            </div>
        </GoogleOAuthProvider>
    );
};

export default GoogleLoginComponent;
